<script setup lang="ts">
	import { useNewsStore } from '~/stores/NewsStore';
	const route = useRoute()
	
	const newsStore = useNewsStore();
	const payload = {
		slug: route.params.slug,
		city: route.params.city,
	}
	await newsStore.getItem(payload);

	const title = newsStore.item?.seo_title ? newsStore.item.seo_title : 'MyCarRental.su';

	useHead({
	  title: title,
		meta: [
			{
				name: 'description',
				content: newsStore.item?.seo_description ? newsStore.item?.seo_description : 'MyCarRental.su',
			},
			{
				name: 'keywords',
				content: newsStore.item?.seo_keywords ? newsStore.item?.seo_keywords : 'MyCarRental.su',
			},
		]
	})
</script>

<template>
	<div class="page">
		<Banner :title="newsStore.item.title" :image="`${newsStore.item.full_image_path}`" />
		<div class="content">
			<div class="container">
				<div class="content__wrapper">
					<BookingForm keep-alive />
					<div class="content__main">
						<div class="news">
							<div class="content__main-head"></div>
							<div class="content__article" v-if="newsStore.item">
								<div v-html="newsStore.item.content" v-if="newsStore.item && newsStore.item.content"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
	.content {
		position: relative;
		z-index: 10;
	}

	.content__article {
		line-height: 1.4;
		padding-bottom: 20px;
		img {
			width: 736px;
			height: auto;
		}
		p {
			margin-bottom: 20px;
		}
		a {
			color: #FF6D10;
			text-decoration: underline;
		}
		h2 {
			margin-bottom: 20px;
			font-weight: 300;
			font-size: 27px;
		}
		h3 {
			margin-bottom: 10px;
			font-weight: 300;
			font-size: 20px;
			font-weight: bold;
		}
		ul {
			list-style-type: disc;
			margin-left: 20px;
			margin-bottom: 30px;
			li {
				margin-bottom: 3px;
			}
		}
		strong {
			font-weight: bold;
		}
	}
</style>